<template>
<div id="contacts_href" class="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-3 lg:gap-10 my-20 px-10">
  <div class="lg:col-span-2">
    <div class="flex justify-between mb-10">
      <img src="@/assets/title-contact.svg" alt="聯絡我們">
      <div class="hidden sm:block">
      <a href="/contacts"><div class="contact-btn text-white flex items-center justify-center">更多資訊&ensp;></div></a>
      </div>
    </div>
    <p class="text-lg text-left mb-10">只要您有任何與農業部生物多樣性研究所相關的需求，您可以透過下列地址、電話或電子信箱聯絡我們。
      本館提供植物研究人員查閱標本及學校團體參觀教學服務，如欲查閱標本或教學參觀，請事先聯絡申請，以便安排相關事宜。</p>
      <div class="grid sm:grid-cols-5 gap-y-3">
        <div class="sm:col-span-3">
        <div class="flex space-x-5 items-center">
          <img src="@/assets/address.svg" alt="地址">
          <p class="text-lg text-left">552 南投縣集集鎮民生東路一號</p>
        </div>
        </div>
        <div class="sm:col-span-2">
        <div class="flex space-x-5 items-center">
          <img src="@/assets/mail.svg" alt="信箱">
          <p class="text-lg text-left">taie@tbri.gov.tw</p>
        </div>
        </div>
        <div class="sm:col-span-3">
        <div class="flex space-x-5 items-center">
          <img src="@/assets/phone.svg" alt="電話">
          <p class="text-lg text-left">(049) 276-1331 #213</p>
        </div>
        </div>
        <div class="sm:col-span-2">
        <div class="flex space-x-5 items-center">
          <img src="@/assets/fax.svg" alt="傳真">
          <p class="text-lg text-left">(049) 276-1801</p>
        </div>
        </div>
      </div>
      <div class="block sm:hidden">
        <div class="flex justify-center mt-10">
          <a href="/contacts"><div class="contact-btn text-white flex items-center justify-center">更多資訊&ensp;></div></a>
        </div>
      </div>
  </div>
  <div class="hidden lg:block">
  <div class="flex items-center justify-center h-full">
    <img src="@/assets/contact-pic.png" alt="contact image">
  </div>
  </div>
</div>
<div class="footer-bg"></div>
</template>

<script>
export default {
  name: "Contacts",
};
</script>

<style scoped>
.contact-btn{
  width: 125px;
  height: 50px;
  background-color: #C9A798;
  mask-image: url(../../assets/btn-bg.svg);
}

.contact-btn:hover {
  background-color: #A8897C;
}

.footer-bg {
  width: 100%;
  height: 10px;
  background-image: url("../../assets/footer-bg.svg");
}
</style>
